module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Food/French Bread-9c536c70ee620131bed52d7702f83641.svg";